import { render, staticRenderFns } from "./SiteForeman.vue?vue&type=template&id=0335e936&scoped=true"
import script from "./SiteForeman.vue?vue&type=script&lang=js"
export * from "./SiteForeman.vue?vue&type=script&lang=js"
import style0 from "./SiteForeman.vue?vue&type=style&index=0&id=0335e936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0335e936",
  null
  
)

export default component.exports